module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Jliu"))).then(() => parcelRequire('d0iPb'));